import React from 'react';
import { useTableSelector } from 'hooks/useTableSelector';

import styles from './HandRank.module.scss';

const HandRank: React.FC = () => {
  const handRankDisplay = useTableSelector((table) => table.game.handRank);

  return (
    <>
      {!!handRankDisplay && (
        <div className={styles.HandRank}>
          <div className={styles.RankText}>{handRankDisplay}</div>
        </div>
      )}
    </>
  );
};

export default HandRank;
